import type { SurveyDto, UxSignalsSurveyDto } from '@helsenorge/framework-utils/additional-page-content';
import { getSurveysCookie, setSurveysCookie } from '@helsenorge/framework-utils/additional-page-content/utils';

import FeedbackModalWrapper from './FeedBackModalWrapper';
import UxSignalsWrapper from './UxSignalWrapper';

export interface FeedbackModalContainerProps {
  surveys: SurveyDto[] | UxSignalsSurveyDto[];
}

const FeedbackModalContainer: React.FC<FeedbackModalContainerProps> = props => {
  const handleClose = (id: string): void => {
    setSurveysCookie(id);
  };

  const surveyCookie = getSurveysCookie();

  const unansweredSurveys = props.surveys.filter(survey => !surveyCookie || !(survey.id in surveyCookie));
  const surveys = unansweredSurveys?.filter(survey => survey._type === 'survey');
  const uxSignalSurveys = unansweredSurveys?.filter(survey => survey._type === 'uxsignals');

  if (surveys?.length === 0 && uxSignalSurveys?.length === 0) {
    return null;
  }

  return (
    <div data-testid="feedback-modal-container">
      {surveys?.map(survey => (
        <FeedbackModalWrapper survey={survey} key={survey.id} onClose={handleClose} />
      ))}

      {uxSignalSurveys?.map(survey => (
        <UxSignalsWrapper survey={survey} key={survey.id} />
      ))}
    </div>
  );
};

export default FeedbackModalContainer;
